// extracted by mini-css-extract-plugin
export var center = "_5k-2";
export var clickableRow = "_5k-5";
export var expandedRow = "_5k-7";
export var hoverable = "_5k-4";
export var left = "_5k-1";
export var right = "_5k-3";
export var row = "_5k-0";
export var selectedRow = "_5k-6";
export var summaryRow = "_5k-8";